// Toda chamada do axios ao backend leva o login do painel (token do Firebase): as rotas que
// enviam mensagens, ligam o bot ou usam a IA conferem se o e-mail tem acesso à empresa.
import axios from 'axios';
import { auth } from './firebaseConfig';

const apiUrl = process.env.REACT_APP_API_URL;

axios.interceptors.request.use(async (config) => {
  if (apiUrl && String(config.url || '').startsWith(apiUrl) && auth.currentUser && !config.headers.has('Authorization')) {
    config.headers.set('Authorization', `Bearer ${await auth.currentUser.getIdToken()}`);
  }
  return config;
});
